package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.state.Stateful
import ai.flowstorm.common.state.StatefulValue
import ai.flowstorm.common.ui.EntityForm
import ai.flowstorm.studio.model.GeneratedSample
import ai.flowstorm.studio.resources.GeneratedSampleResource
import ai.flowstorm.studio.ui.form.EntityId
import io.kvision.core.PosFloat
import io.kvision.form.text.Text
import io.kvision.html.button
import io.kvision.i18n.tr
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.launch

class GeneratedSampleForm(model: GeneratedSampleResource, val viewer: GeneratedSampleViewer) : EntityForm<GeneratedSample>(model),
    Stateful<GeneratedSampleForm.State> by StatefulValue(State()) {

    data class State(
        var loading: Boolean = false,
        var data: GeneratedSample? = null,
    )

    init {
        add(
            GeneratedSample::_id,
            EntityId(label = tr("Object ID"))
        )
        add(
            GeneratedSample::serviceName,
            Text(label = tr("Service"))
        )
        add(
            GeneratedSample::modelId,
            Text(label = tr("Model ID"))
        )
        add(
            GeneratedSample::timestamp,
            Text(label = tr("Timestamp"))
        )
        add(
            GeneratedSample::turn_id,
            EntityId(label = tr("Turn ID"))
        )
        add(
            simplePanel {
                float = PosFloat.RIGHT
                button(tr("Resubmit")).bind(this@GeneratedSampleForm) {
                    disabled = it.loading
                    text = if (it.loading) tr("Processing ...") else tr("Resubmit")
                }.onClick {
                    mainScope.launch {
                        state.loading = true
                        val newOutput = GeneratedSampleResource.resubmit(this@GeneratedSampleForm.entity!!)
                        super.load(newOutput)
                        viewer.load(newOutput)
                        state.loading = false
                    }
                }
            }
        )
    }

    override fun load(entity: GeneratedSample): GeneratedSample {
        disableAll()
        return super.load(entity)
    }
}